import {
  Box,
  ClickAwayListener,
  Paper,
  PopoverVirtualElement,
  Popper,
  PopperPlacementType,
  SxProps,
} from '@mui/material'
import React from 'react'

interface Props {
  children?: React.ReactNode[] | React.ReactNode
  open: boolean
  onClose: () => void
  anchorEl:
    | Element
    | (() => Element)
    | PopoverVirtualElement
    | (() => PopoverVirtualElement)
    | null
    | undefined
  paperSx?: SxProps
  placement?: PopperPlacementType
}

const ChipMenuDialog: React.FC<Props> = ({
  children,
  open,
  anchorEl,
  onClose,
  paperSx,
  placement = 'bottom-start',
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      sx={{ boxShadow: 'none', overflow: 'visible', zIndex: 9999 }}
      slotProps={{
        root: {
          id: 'popover-presentation-layer',
        },
      }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Box mt='12px'>
          <Paper
            id='popover-container'
            sx={{
              overflow: 'visible',
              padding: '1rem',
              boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14)',
              ...paperSx,
            }}
          >
            {children}
          </Paper>
        </Box>
      </ClickAwayListener>
    </Popper>
  )
}

export default ChipMenuDialog
